export default "__VITE_ASSET__7d20bc15__"